import { createContext, useContext } from 'react';

export type SidebarCollapsedContextValue = {
  collapsed: boolean;
};

const SidebarCollapsedContext = createContext<SidebarCollapsedContextValue>({
  collapsed: false
});

export const SidebarCollapsedProvider = SidebarCollapsedContext.Provider;

export function useSidebarCollapsed(): SidebarCollapsedContextValue {
  return useContext(SidebarCollapsedContext);
}
